import { EventEmitter, Component, ContentChild, Input, Output, ViewChild, Injectable, ɵɵdefineInjectable, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { delay } from 'rxjs/operators';
import { trigger, transition, style, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["customContent"];
function PivotTableComponent_ng_container_0_div_1_ng_container_8_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const mapping_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("value", mapping_r11.property);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", mapping_r11.heading, " ");
} }
function PivotTableComponent_ng_container_0_div_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_div_1_ng_container_8_option_1_Template, 2, 2, "option", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mapping_r11 = ctx.$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r10.isColumnSelected(mapping_r11));
} }
function PivotTableComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "div", 12)(3, "label", 13);
    ɵngcc0.ɵɵtext(4, "Add Column");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 14);
    ɵngcc0.ɵɵlistener("change", function PivotTableComponent_ng_container_0_div_1_Template_select_change_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r14.addSelectedColumn($event.target.value)); });
    ɵngcc0.ɵɵelementStart(6, "option", 15);
    ɵngcc0.ɵɵtext(7, "--");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, PivotTableComponent_ng_container_0_div_1_ng_container_8_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(9, "div", 12)(10, "label", 13);
    ɵngcc0.ɵɵtext(11, "\u00A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 16);
    ɵngcc0.ɵɵlistener("click", function PivotTableComponent_ng_container_0_div_1_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r16.clearSelections()); });
    ɵngcc0.ɵɵtext(13, " Clear ");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.isLoading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.columnMappings);
} }
function PivotTableComponent_ng_container_0_ng_container_7_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sc_r18 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sc_r18.heading, " ");
} }
function PivotTableComponent_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_ng_container_7_th_1_Template, 2, 1, "th", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.selectedColumns);
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "a", 23);
    ɵngcc0.ɵɵlistener("click", function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_2_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r29); const i_r21 = ɵngcc0.ɵɵnextContext().index; const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r27.moveColumnLeft(i_r21)); });
    ɵngcc0.ɵɵtext(2, " < ");
    ɵngcc0.ɵɵelementEnd()();
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "a", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const sc_r20 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(sc_r20.heading);
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_5_ng_container_4_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const mapping_r32 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("value", mapping_r32.property);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", mapping_r32.heading, " ");
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_5_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_ng_container_8_th_1_div_5_ng_container_4_option_1_Template, 2, 2, "option", 17);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mapping_r32 = ctx.$implicit;
    const ctx_r31 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r31.isColumnSelected(mapping_r32));
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25)(1, "select", 26);
    ɵngcc0.ɵɵlistener("change", function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_5_Template_select_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const i_r21 = ɵngcc0.ɵɵnextContext().index; const ctx_r35 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r35.onSelectedColumnChange(i_r21, $event.target.value)); });
    ɵngcc0.ɵɵelementStart(2, "option", 15);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PivotTableComponent_ng_container_0_ng_container_8_th_1_div_5_ng_container_4_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const sc_r20 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r24 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", sc_r20.property);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(sc_r20.heading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r24.columnMappings);
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "a", 23);
    ɵngcc0.ɵɵlistener("click", function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_6_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r41); const i_r21 = ɵngcc0.ɵɵnextContext().index; const ctx_r39 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r39.moveColumnRight(i_r21)); });
    ɵngcc0.ɵɵtext(2, " > ");
    ɵngcc0.ɵɵelementEnd()();
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "a", 23);
    ɵngcc0.ɵɵlistener("click", function PivotTableComponent_ng_container_0_ng_container_8_th_1_div_7_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r44); const sc_r20 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r42 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r42.removeSelectedColumn(sc_r20)); });
    ɵngcc0.ɵɵtext(2, " X ");
    ɵngcc0.ɵɵelementEnd()();
} }
function PivotTableComponent_ng_container_0_ng_container_8_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 19)(1, "div", 20);
    ɵngcc0.ɵɵtemplate(2, PivotTableComponent_ng_container_0_ng_container_8_th_1_div_2_Template, 3, 0, "div", 21);
    ɵngcc0.ɵɵelementStart(3, "div", 12);
    ɵngcc0.ɵɵtemplate(4, PivotTableComponent_ng_container_0_ng_container_8_th_1_div_4_Template, 3, 1, "div", 6);
    ɵngcc0.ɵɵtemplate(5, PivotTableComponent_ng_container_0_ng_container_8_th_1_div_5_Template, 5, 3, "div", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, PivotTableComponent_ng_container_0_ng_container_8_th_1_div_6_Template, 3, 0, "div", 21);
    ɵngcc0.ɵɵtemplate(7, PivotTableComponent_ng_container_0_ng_container_8_th_1_div_7_Template, 3, 0, "div", 21);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const sc_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", i_r21 > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r19.enableColumnSelection || sc_r20.sticky);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.enableColumnSelection && !sc_r20.sticky);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r21 < ctx_r19.selectedColumns.length - 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.enableColumnSelection && !sc_r20.sticky);
} }
function PivotTableComponent_ng_container_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_ng_container_8_th_1_Template, 8, 5, "th", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.selectedColumns);
} }
function PivotTableComponent_ng_container_0_ng_container_9_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ac_r45 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ac_r45.heading, " ");
} }
function PivotTableComponent_ng_container_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_ng_container_9_th_1_Template, 2, 1, "th", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ac_r45 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ac_r45.hidden);
} }
function PivotTableComponent_ng_container_0_th_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "th", 27);
} }
function PivotTableComponent_ng_container_0_tr_12_ng_container_1_td_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵattribute("rowspan", column_r51.rowspan);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", column_r51.value, " ");
} }
function PivotTableComponent_ng_container_0_tr_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_tr_12_ng_container_1_td_1_Template, 2, 2, "td", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r51 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r51.hidden);
} }
const _c1 = function (a0) { return { $implicit: a0 }; };
function PivotTableComponent_ng_container_0_tr_12_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵelementContainer(1, 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r48 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r50 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r50.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, row_r48));
} }
function PivotTableComponent_ng_container_0_tr_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_tr_12_ng_container_1_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(2, PivotTableComponent_ng_container_0_tr_12_td_2_Template, 2, 4, "td", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r48 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", row_r48);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.enableCustomContent);
} }
function PivotTableComponent_ng_container_0_ng_container_13_tr_1_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r58 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", value_r58, " ");
} }
function PivotTableComponent_ng_container_0_ng_container_13_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 30)(1, "td");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, PivotTableComponent_ng_container_0_ng_container_13_tr_1_td_3_Template, 2, 1, "td", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const stickyRow_r56 = ctx.$implicit;
    const ctx_r55 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("colspan", ctx_r55.selectedColumns.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", stickyRow_r56.heading, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", stickyRow_r56.values);
} }
function PivotTableComponent_ng_container_0_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_ng_container_13_tr_1_Template, 4, 3, "tr", 29);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.stickyRows);
} }
const _c2 = function (a0) { return { "is-loading": a0 }; };
const _c3 = function (a0) { return { "is-fullwidth": a0 }; };
function PivotTableComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r60 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_container_0_div_1_Template, 14, 3, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "table", 5)(5, "thead")(6, "tr");
    ɵngcc0.ɵɵtemplate(7, PivotTableComponent_ng_container_0_ng_container_7_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(8, PivotTableComponent_ng_container_0_ng_container_8_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(9, PivotTableComponent_ng_container_0_ng_container_9_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(10, PivotTableComponent_ng_container_0_th_10_Template, 1, 0, "th", 8);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(11, "tbody");
    ɵngcc0.ɵɵtemplate(12, PivotTableComponent_ng_container_0_tr_12_Template, 3, 2, "tr", 7);
    ɵngcc0.ɵɵtemplate(13, PivotTableComponent_ng_container_0_ng_container_13_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(14, "agx-paginator", 9);
    ɵngcc0.ɵɵlistener("pageChange", function PivotTableComponent_ng_container_0_Template_agx_paginator_pageChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r60); const ctx_r59 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r59.onPageChange($event)); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.enableColumnSelection);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c2, ctx_r0.isLoading));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c3, ctx_r0.isFullWidth));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.staticColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.staticColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.aggregatedColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.enableCustomContent);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.pageRows);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedColumns.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("totalItems", ctx_r0.totalItems)("itemsPerPage", ctx_r0.itemsPerPage);
} }
function PivotTableComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 31)(1, "h1", 32);
    ɵngcc0.ɵɵtext(2, " No data to display");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c2, ctx_r2.isLoading));
} }
function PaginatorComponent_nav_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 8);
    ɵngcc0.ɵɵlistener("click", function PaginatorComponent_nav_0_ng_container_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r5.goToPage(1)); });
    ɵngcc0.ɵɵtext(2, " First ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function PaginatorComponent_nav_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 9);
    ɵngcc0.ɵɵlistener("click", function PaginatorComponent_nav_0_ng_container_6_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r7.goToPage(ctx_r7.lastPageNumber)); });
    ɵngcc0.ɵɵtext(2, " Last ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c4 = function (a0) { return { "is-current": a0 }; };
function PaginatorComponent_nav_0_li_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li")(1, "button", 6);
    ɵngcc0.ɵɵlistener("click", function PaginatorComponent_nav_0_li_11_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r9.goToPage(ctx_r9.buttonTwoNumber)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c4, ctx_r3.currentPage === ctx_r3.buttonTwoNumber));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.buttonTwoNumber, " ");
} }
function PaginatorComponent_nav_0_li_12_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li")(1, "button", 6);
    ɵngcc0.ɵɵlistener("click", function PaginatorComponent_nav_0_li_12_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.goToPage(ctx_r11.buttonThreeNumber)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c4, ctx_r4.currentPage === ctx_r4.buttonThreeNumber));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.buttonThreeNumber, " ");
} }
function PaginatorComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nav", 1);
    ɵngcc0.ɵɵtemplate(1, PaginatorComponent_nav_0_ng_container_1_Template, 3, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementStart(2, "button", 3);
    ɵngcc0.ɵɵlistener("click", function PaginatorComponent_nav_0_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.goToPage(ctx_r13.currentPage - 1)); });
    ɵngcc0.ɵɵtext(3, " Previous ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 4);
    ɵngcc0.ɵɵlistener("click", function PaginatorComponent_nav_0_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r15.goToPage(ctx_r15.currentPage + 1)); });
    ɵngcc0.ɵɵtext(5, " Next ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, PaginatorComponent_nav_0_ng_container_6_Template, 3, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementStart(7, "ul", 5)(8, "li")(9, "button", 6);
    ɵngcc0.ɵɵlistener("click", function PaginatorComponent_nav_0_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.goToPage(ctx_r16.buttonOneNumber)); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(11, PaginatorComponent_nav_0_li_11_Template, 3, 4, "li", 2);
    ɵngcc0.ɵɵtemplate(12, PaginatorComponent_nav_0_li_12_Template, 3, 4, "li", 2);
    ɵngcc0.ɵɵelementStart(13, "li")(14, "span", 7);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentPage > 1 && ctx_r0.lastPageNumber > 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r0.canGoPrevious);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r0.canGoNext);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentPage !== ctx_r0.lastPageNumber && ctx_r0.lastPageNumber > 1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c4, ctx_r0.currentPage === ctx_r0.buttonOneNumber));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.buttonOneNumber, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lastPageNumber > 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lastPageNumber > 2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2(" Page ", ctx_r0.currentPage, " of ", ctx_r0.lastPageNumber, " ");
} }
const _c5 = ["image"];
const _c6 = ["progressRingCircle"];
function AvatarComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("font-size", ctx_r0.fontSize);
    ɵngcc0.ɵɵproperty("@fadeInAnimation", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.initial, " ");
} }
function AvatarComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 11)(2, "g");
    ɵngcc0.ɵɵelement(3, "path", 12)(4, "path", 13);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("@fadeInAnimation", undefined);
} }
function AvatarComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14)(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@fadeInAnimation", undefined);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r3.uploadProgress, "%");
} }
const _c7 = function (a0) { return { "invisible": a0 }; };
const _c8 = function (a0) { return { "visible": a0 }; };
function ColumnMapping() { }
if (false) {
    /** @type {?} */
    ColumnMapping.prototype.property;
    /** @type {?} */
    ColumnMapping.prototype.heading;
    /** @type {?|undefined} */
    ColumnMapping.prototype.sticky;
}
/**
 * @record
 */
function AggregatedColumn() { }
if (false) {
    /** @type {?} */
    AggregatedColumn.prototype.property;
    /** @type {?} */
    AggregatedColumn.prototype.aggregator;
    /** @type {?} */
    AggregatedColumn.prototype.heading;
    /** @type {?|undefined} */
    AggregatedColumn.prototype.hidden;
}
/**
 * @record
 */
function StickyRow() { }
if (false) {
    /** @type {?} */
    StickyRow.prototype.properties;
    /** @type {?|undefined} */
    StickyRow.prototype.values;
    /** @type {?} */
    StickyRow.prototype.aggregator;
    /** @type {?} */
    StickyRow.prototype.heading;
}
/**
 * @record
 */
function Column() { }
if (false) {
    /** @type {?} */
    Column.prototype.property;
    /** @type {?} */
    Column.prototype.value;
    /** @type {?} */
    Column.prototype.rowspan;
}
/** @type {?} */
const isObject = (/**
 * @param {?} object
 * @return {?}
 */
(object) => {
    return typeof object === 'object' && !Array.isArray(object);
});
const ɵ0 = isObject;
class PivotTableComponent {
    constructor() {
        this.data = [];
        this.aggregatedColumns = [];
        this.stickyRows = [];
        this.isFullWidth = false;
        this.itemsPerPage = 20;
        this.isLoading = false;
        this.enableColumnSelection = true;
        this.enableCustomContent = false;
        this.staticColumns = false;
        // tslint:disable-next-line: variable-name
        this._selectedColumns = [];
        this.selectedColumnsChange = new EventEmitter();
        this.currentPage = 1;
        this.rows = [];
        this.groupedData = [];
    }
    /**
     * @return {?}
     */
    get selectedColumns() {
        return this._selectedColumns;
    }
    /**
     * @param {?} selectedColumns
     * @return {?}
     */
    set selectedColumns(selectedColumns) {
        if (selectedColumns === this._selectedColumns) {
            return;
        }
        this._selectedColumns = selectedColumns;
        this.selectedColumnsChange.emit(this._selectedColumns);
    }
    /**
     * @return {?}
     */
    get totalItems() {
        return this.rows.length;
    }
    /**
     * @return {?}
     */
    get pageLowerBound() {
        return (this.currentPage * this.itemsPerPage) - this.itemsPerPage;
    }
    /**
     * @return {?}
     */
    get pageUpperBound() {
        return this.currentPage * this.itemsPerPage;
    }
    /**
     * @return {?}
     */
    get pageRows() {
        /** @type {?} */
        const pageRows = this.rows.slice(this.pageLowerBound, this.pageUpperBound);
        this.setColumnRowSpans(this.selectedColumns, pageRows);
        return pageRows;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.staticColumns) {
            this.enableColumnSelection = false;
        }
        this.aggregatedColumns.push({
            property: 'id',
            aggregator: (/**
             * @param {?} iterable
             * @return {?}
             */
            (iterable) => iterable),
            heading: 'ID',
            hidden: true
        });
        this.rows = [];
        this.rows.push(this.aggregatedColumns.map((/**
         * @param {?} ac
         * @return {?}
         */
        (ac) => {
            /** @type {?} */
            const data = this.data.map((/**
             * @param {?} obj
             * @return {?}
             */
            obj => obj[ac.property]));
            return {
                property: ac.property,
                value: ac.aggregator(data),
                rowspan: 1,
                hidden: ac.hidden
            };
        })));
        this.buildViewModel();
        this.buildStickyRows();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.data || changes.selectedColumns) {
            this.buildViewModel();
        }
    }
    /**
     * Fired when the new column dropdown change event is fired,
     * adds to selected columns and rebuilds table rows
     * @param {?} property The property to add to the selected columns
     * @return {?}
     */
    addSelectedColumn(property) {
        /** @type {?} */
        let mapping;
        if (property === 'id') {
            /** @type {?} */
            const index = this.aggregatedColumns.indexOf(this.aggregatedColumns.find((/**
             * @param {?} ac
             * @return {?}
             */
            (ac) => ac.property === 'id')));
            if (index !== -1) {
                this.aggregatedColumns.splice(index, 1);
            }
            mapping = {
                property: 'id',
                heading: 'ID',
                sticky: false
            };
        }
        else {
            mapping = this.columnMappings.find((/**
             * @param {?} m
             * @return {?}
             */
            (m) => m.property === property));
        }
        if (!this.isColumnSelected(mapping)) {
            this.selectedColumns.push(mapping);
            this.buildViewModel();
        }
    }
    /**
     * Removes a selected column and rebuilds the table rows
     * @param {?} mapping The ColumnMapping to remove from the selected rows
     * @return {?}
     */
    removeSelectedColumn(mapping) {
        if (mapping.property === 'id') {
            this.aggregatedColumns.push({
                property: 'id',
                aggregator: (/**
                 * @param {?} iterable
                 * @return {?}
                 */
                (iterable) => iterable),
                heading: 'ID',
                hidden: true
            });
        }
        this.selectedColumns.splice(this.selectedColumns.indexOf(mapping), 1);
        this.buildViewModel();
    }
    /**
     * Change an existing selected column to a new column
     * @param {?} index
     * @param {?} property
     * @return {?}
     */
    onSelectedColumnChange(index, property) {
        /** @type {?} */
        const mapping = this.columnMappings.find((/**
         * @param {?} m
         * @return {?}
         */
        m => m.property === property));
        if (!this.isColumnSelected(mapping)) {
            this.selectedColumns[index] = mapping;
            this.buildViewModel();
        }
    }
    /**
     * Move a specified column one index to the right
     * @param {?} index The index of the column to shift
     * @return {?}
     */
    moveColumnRight(index) {
        /** @type {?} */
        const temp = this.selectedColumns[index];
        this.selectedColumns[index] = this.selectedColumns[index + 1];
        this.selectedColumns[index + 1] = temp;
        this.buildViewModel();
    }
    /**
     * Move a specified column one index to the left
     * @param {?} index The index of the column to shift
     * @return {?}
     */
    moveColumnLeft(index) {
        /** @type {?} */
        const temp = this.selectedColumns[index];
        this.selectedColumns[index] = this.selectedColumns[index - 1];
        this.selectedColumns[index - 1] = temp;
        this.buildViewModel();
    }
    /**
     * @param {?} columnMapping
     * @return {?}
     */
    isColumnSelected(columnMapping) {
        return this.selectedColumns.findIndex((/**
         * @param {?} selected
         * @return {?}
         */
        selected => selected.property === columnMapping.property)) > -1;
    }
    /**
     * @param {?} pageNumber
     * @return {?}
     */
    onPageChange(pageNumber) {
        this.currentPage = pageNumber;
    }
    /**
     * Clear the column selections
     * @return {?}
     */
    clearSelections() {
        this.selectedColumns = [];
        this.buildViewModel();
    }
    /**
     * Build the table rows
     * @return {?}
     */
    buildViewModel() {
        if (this.selectedColumns.length > 0) {
            this.groupedData = this.nest(this.selectedColumns.map((/**
             * @param {?} c
             * @return {?}
             */
            (c) => c.property)), this.data);
            this.rows = [];
            this.traverseGroupedData(this.groupedData);
        }
        else {
            this.groupedData = [];
            this.rows = [];
            this.rows.push(this.aggregatedColumns.map((/**
             * @param {?} ac
             * @return {?}
             */
            (ac) => {
                /** @type {?} */
                const data = this.data.map((/**
                 * @param {?} obj
                 * @return {?}
                 */
                obj => obj[ac.property]));
                return { property: ac.property, value: ac.aggregator(data), rowspan: 1, hidden: ac.hidden };
            })));
        }
    }
    /**
     * Recursively grouped data into a nested object based on property keys
     * @private
     * @param {?} keys The keys to group the data on
     * @param {?} array The data to group
     * @return {?}
     */
    nest(keys, array) {
        if (keys.length === 0) {
            return array;
        }
        /** @type {?} */
        const first = keys[0];
        /** @type {?} */
        const rest = keys.slice(1);
        return this.mapValue(this.groupBy(first, array), (/**
         * @param {?} value
         * @return {?}
         */
        (value) => {
            return this.nest(rest, value);
        }));
    }
    /**
     * Get a copy of an object after a mutator has been applied to each property
     * @private
     * @param {?} object The object to copy
     * @param {?} iteratee The property mutator
     * @return {?}
     */
    mapValue(object, iteratee) {
        object = Object(object);
        /** @type {?} */
        const result = {};
        Object.keys(object).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            result[key] = iteratee(object[key]);
        }));
        return result;
    }
    /**
     * Groups an array of objects based on a object key
     * @private
     * @param {?} key The object key to group the data on
     * @param {?} array The array to group
     * @return {?}
     */
    groupBy(key, array) {
        /** @type {?} */
        const objectsByKeyValue = {};
        // simple for loop for best performance
        for (let i = 0, l = array.length; i < l; i++) {
            /** @type {?} */
            let value = array[i][key];
            if (!value && key.includes('_accessObject_')) {
                // dig down into specified object(s)
                value = key.split('_accessObject_').reduce((/**
                 * @param {?} j
                 * @param {?} k
                 * @return {?}
                 */
                (j, k) => j && j[k]), array[i]);
            }
            if (typeof objectsByKeyValue[value] === 'undefined') {
                objectsByKeyValue[value] = [];
            }
            objectsByKeyValue[value].push(array[i]);
        }
        return objectsByKeyValue;
    }
    /**
     * Recursively traverse the grouped data and build table rows
     * @private
     * @param {?} data The grouped data object
     * @return {?}
     */
    traverseGroupedData(data) {
        if (isObject(data)) {
            /** @type {?} */
            const keys = Object.keys(data);
            keys.forEach((/**
             * @param {?} key
             * @return {?}
             */
            key => {
                if (isObject(data[key])) {
                    this.traverseGroupedData(data[key]);
                }
                else {
                    this.rows.push(this.selectedColumns.map((/**
                     * @param {?} column
                     * @return {?}
                     */
                    (column) => {
                        /** @type {?} */
                        let value = data[key][0][column.property];
                        if (!value && column.property.includes('_accessObject_')) {
                            // If no value and property contains specific string indicating we want to dig down
                            // into a nested object, split on the string and traverse the object.
                            // Arbitrary levels of nesting is supported
                            value = column.property.split('_accessObject_').reduce((/**
                             * @param {?} j
                             * @param {?} k
                             * @return {?}
                             */
                            (j, k) => j && j[k]), data[key][0]);
                        }
                        return {
                            property: column.property,
                            value,
                            rowspan: 1
                        };
                    })).concat(this.aggregatedColumns.map((/**
                     * @param {?} ac
                     * @return {?}
                     */
                    (ac) => {
                        /** @type {?} */
                        const groupedData = data[key].map((/**
                         * @param {?} obj
                         * @return {?}
                         */
                        (obj) => obj[ac.property]));
                        return {
                            property: ac.property,
                            value: ac.aggregator(groupedData),
                            rowspan: 1,
                            hidden: ac.hidden
                        };
                    }))));
                }
            }));
        }
    }
    /**
     * Recursivley set the column rowspans of a table based upon the occourence of value in the data subset
     * @private
     * @param {?} selectedColumns
     * @param {?} rows
     * @return {?}
     */
    setColumnRowSpans(selectedColumns, rows) {
        if (selectedColumns.length > 0 && rows.length > 0) {
            /** @type {?} */
            const columnMapping = selectedColumns[0];
            /** @type {?} */
            const groupedRows = [];
            /** @type {?} */
            const processedValues = [];
            if (rows.length > 0) {
                rows.forEach((/**
                 * @param {?} row
                 * @return {?}
                 */
                (row) => {
                    /** @type {?} */
                    const column = row.find((/**
                     * @param {?} c
                     * @return {?}
                     */
                    c => c.property === columnMapping.property));
                    if (column) {
                        if (processedValues.indexOf(column.value) === -1) {
                            processedValues.push(column.value);
                            groupedRows.push([row]);
                        }
                        else {
                            groupedRows[groupedRows.length - 1].push(row);
                            /** @type {?} */
                            const first = groupedRows[groupedRows.length - 1][0].find((/**
                             * @param {?} c
                             * @return {?}
                             */
                            (c) => c.property === column.property));
                            first.rowspan++;
                            row.splice(row.indexOf(column), 1);
                        }
                    }
                }));
            }
            selectedColumns = selectedColumns.slice(1);
            groupedRows.forEach((/**
             * @param {?} subset
             * @return {?}
             */
            subset => this.setColumnRowSpans(selectedColumns, subset)));
        }
    }
    /**
     * @return {?}
     */
    buildStickyRows() {
        if (this.stickyRows) {
            // Reset sticky row values
            this.stickyRows.forEach((/**
             * @param {?} stickyRow
             * @return {?}
             */
            stickyRow => {
                stickyRow.values = Array(this.aggregatedColumns.filter((/**
                 * @param {?} ac
                 * @return {?}
                 */
                ac => !ac.hidden)).length).fill('-');
            }));
            // Loop though aggregated columns first so that we calculate
            // sticky row values in order of ACs.
            this.aggregatedColumns.forEach((/**
             * @param {?} ac
             * @param {?} index
             * @return {?}
             */
            (ac, index) => {
                this.stickyRows.forEach((/**
                 * @param {?} stickyRow
                 * @return {?}
                 */
                stickyRow => {
                    stickyRow.properties.forEach((/**
                     * @param {?} property
                     * @return {?}
                     */
                    property => {
                        if (property === ac.property) {
                            /** @type {?} */
                            const data = this.data.map((/**
                             * @param {?} obj
                             * @return {?}
                             */
                            obj => obj[ac.property]));
                            // replace '-' with calculated value
                            stickyRow.values.splice(index, 1, stickyRow.aggregator(data));
                        }
                    }));
                }));
            }));
        }
    }
}
PivotTableComponent.ɵfac = function PivotTableComponent_Factory(t) { return new (t || PivotTableComponent)(); };
PivotTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PivotTableComponent, selectors: [["agx-pivot-table"]], contentQueries: function PivotTableComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { data: "data", aggregatedColumns: "aggregatedColumns", stickyRows: "stickyRows", isFullWidth: "isFullWidth", itemsPerPage: "itemsPerPage", isLoading: "isLoading", enableColumnSelection: "enableColumnSelection", enableCustomContent: "enableCustomContent", staticColumns: "staticColumns", selectedColumns: "selectedColumns", columnMappings: "columnMappings" }, outputs: { selectedColumnsChange: "selectedColumnsChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["noData", ""], ["class", "control", "style", "margin-bottom: 10px", 4, "ngIf"], [1, "box", 3, "ngClass"], [1, "table-wrapper"], [1, "table", 2, "margin-bottom", "10px", 3, "ngClass"], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["style", "width: 10%;", 4, "ngIf"], [3, "totalItems", "itemsPerPage", "pageChange"], [1, "control", 2, "margin-bottom", "10px"], [1, "field", "is-grouped"], [1, "control"], [1, "label"], [1, "input", 3, "disabled", "change"], [3, "value"], ["type", "button", 1, "button", 3, "click"], [3, "value", 4, "ngIf"], ["style", "padding-left: 0; padding-right: 0", 4, "ngFor", "ngForOf"], [2, "padding-left", "0", "padding-right", "0"], [1, "field", "has-addons"], ["class", "control", 4, "ngIf"], ["class", "select is-small", 4, "ngIf"], [1, "button", "is-small", 3, "click"], [1, "button", "is-small"], [1, "select", "is-small"], [3, "change"], [2, "width", "10%"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "sticky-row", 4, "ngFor", "ngForOf"], [1, "sticky-row"], [1, "box", "is-flex", 2, "min-height", "160px", "justify-content", "center", "align-items", "center", 3, "ngClass"], [1, "has-text-centered", "is-size-5", "is-flex"]], template: function PivotTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PivotTableComponent_ng_container_0_Template, 15, 15, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, PivotTableComponent_ng_template_1_Template, 3, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.length > 0)("ngIfElse", _r1);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, PaginatorComponent]; }, styles: [".box[_ngcontent-%COMP%]{transition:opacity .2s}.box.is-loading[_ngcontent-%COMP%]{position:relative;pointer-events:none;opacity:.5}.box.is-loading[_ngcontent-%COMP%]:after{-webkit-animation:.5s linear infinite spinAround;animation:.5s linear infinite spinAround;border:.25em solid #000;border-radius:5em;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;position:absolute;top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.table[_ngcontent-%COMP%]{transition:opacity .2s;white-space:nowrap}.table.is-loading[_ngcontent-%COMP%]{position:relative;pointer-events:none;opacity:.5}.table.is-loading[_ngcontent-%COMP%]:after{-webkit-animation:.5s linear infinite spinAround;animation:.5s linear infinite spinAround;border:.25em solid #000;border-radius:5em;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;position:absolute;top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.table-wrapper[_ngcontent-%COMP%]{overflow-x:auto}.table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:middle;font-size:.75em}.sticky-row[_ngcontent-%COMP%]{background-color:#eef6fc;font-weight:700}select[_ngcontent-%COMP%]{font-weight:600}"] });
/** @nocollapse */
PivotTableComponent.ctorParameters = () => [];
PivotTableComponent.propDecorators = {
    template: [{ type: ContentChild, args: ['customContent', { static: false },] }],
    data: [{ type: Input }],
    columnMappings: [{ type: Input }],
    aggregatedColumns: [{ type: Input }],
    stickyRows: [{ type: Input }],
    isFullWidth: [{ type: Input }],
    itemsPerPage: [{ type: Input }],
    isLoading: [{ type: Input }],
    enableColumnSelection: [{ type: Input }],
    enableCustomContent: [{ type: Input }],
    staticColumns: [{ type: Input }],
    selectedColumns: [{ type: Input }],
    selectedColumnsChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PivotTableComponent, [{
        type: Component,
        args: [{ selector: 'agx-pivot-table', template: "<ng-container *ngIf=\"data.length > 0; else noData\">\n\n  <!--#region: drop downs-->\n  <div class=\"control\"\n       style=\"margin-bottom: 10px\"\n       *ngIf=\"enableColumnSelection\">\n    <div class=\"field is-grouped\">\n      <div class=\"control\">\n        <label class=\"label\">Add Column</label>\n        <select (change)=\"addSelectedColumn($event.target.value)\"\n                [disabled]=\"isLoading\"\n                class=\"input\">\n          <option [value]=\"null\">--</option>\n          <ng-container *ngFor=\"let mapping of columnMappings\">\n            <option *ngIf=\"!isColumnSelected(mapping)\"\n                    [value]=\"mapping.property\">{{ mapping.heading }}\n            </option>\n          </ng-container>\n        </select>\n      </div>\n      <div class=\"control\">\n        <label class=\"label\">&nbsp;</label>\n        <button class=\"button\"\n                type=\"button\"\n                (click)=\"clearSelections()\">\n          Clear\n        </button>\n      </div>\n    </div>\n  </div>\n  <!--#endregion: drop downs-->\n\n  <!--#region: table-->\n  <div class=\"box\"\n       [ngClass]=\"{'is-loading': isLoading}\">\n    <div class=\"table-wrapper\">\n      <table class=\"table\"\n             style=\"margin-bottom: 10px\"\n             [ngClass]=\"{'is-fullwidth': isFullWidth}\">\n        <thead>\n          <tr>\n            <ng-container *ngIf=\"staticColumns\">\n              <th *ngFor=\"let sc of selectedColumns\">\n                {{ sc.heading }}\n              </th>\n            </ng-container>\n            <ng-container *ngIf=\"!staticColumns\">\n              <th *ngFor=\"let sc of selectedColumns; index as i\"\n                  style=\"padding-left: 0; padding-right: 0\">\n                <div class=\"field has-addons\">\n                  <div class=\"control\"\n                       *ngIf=\"i > 0\">\n                    <a class=\"button is-small\"\n                       (click)=\"moveColumnLeft(i)\">\n                      &lt;\n                    </a>\n                  </div>\n                  <div class=\"control\">\n                    <div *ngIf=\"!enableColumnSelection || sc.sticky\"><a class=\"button is-small\">{{ sc.heading }}</a></div>\n                    <div *ngIf=\"enableColumnSelection && !sc.sticky\" class=\"select is-small\">\n                      <select (change)=\"onSelectedColumnChange(i, $event.target.value)\">\n                        <option [value]=\"sc.property\">{{ sc.heading }}</option>\n                        <ng-container *ngFor=\"let mapping of columnMappings\">\n                          <option *ngIf=\"!isColumnSelected(mapping)\"\n                                  [value]=\"mapping.property\">{{ mapping.heading }}\n                          </option>\n                        </ng-container>\n                      </select>\n                    </div>\n                  </div>\n                  <div class=\"control\"\n                       *ngIf=\"i < selectedColumns.length - 1\">\n                    <a class=\"button is-small\"\n                       (click)=\"moveColumnRight(i)\">\n                      &gt;\n                    </a>\n                  </div>\n                  <div class=\"control\" *ngIf=\"enableColumnSelection && !sc.sticky\">\n                    <a class=\"button is-small\"\n                       (click)=\"removeSelectedColumn(sc)\">\n                      X\n                    </a>\n                  </div>\n                </div>\n              </th>\n            </ng-container>\n            <ng-container *ngFor=\"let ac of aggregatedColumns\">\n              <th *ngIf=\"!ac.hidden\">\n                {{ ac.heading }}\n              </th>\n            </ng-container>\n            <th *ngIf=\"enableCustomContent\" style=\"width: 10%;\"></th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let row of pageRows\">\n            <ng-container *ngFor=\"let column of row\">\n              <td *ngIf=\"!column.hidden\"\n                  [attr.rowspan]=\"column.rowspan\">\n                {{ column.value }}\n              </td>\n            </ng-container>\n            <td *ngIf=\"enableCustomContent\">\n              <ng-container [ngTemplateOutlet]=\"template\"\n                            [ngTemplateOutletContext]=\"{ $implicit: row } \">\n              </ng-container>\n            </td>\n          </tr>\n          <ng-container *ngIf=\"selectedColumns.length > 0\">\n            <tr *ngFor=\"let stickyRow of stickyRows\" class=\"sticky-row\">\n              <td [attr.colspan]=\"selectedColumns.length\">\n                {{ stickyRow.heading }}\n              </td>\n              <td *ngFor=\"let value of stickyRow.values\">\n                {{ value }}\n              </td>\n            </tr>\n          </ng-container>\n        </tbody>\n      </table>\n    </div>\n    <agx-paginator [totalItems]=\"totalItems\"\n                   [itemsPerPage]=\"itemsPerPage\"\n                   (pageChange)=\"onPageChange($event)\">\n    </agx-paginator>\n  </div>\n  <!--#endregion: table-->\n</ng-container>\n\n<ng-template #noData>\n  <div class=\"box is-flex\"\n       style=\"min-height: 160px; justify-content: center; align-items: center\"\n       [ngClass]=\"{ 'is-loading': isLoading }\">\n    <h1 class=\"has-text-centered is-size-5 is-flex\"> No data to display</h1>\n  </div>\n</ng-template>\n", styles: [".box{transition:opacity .2s}.box.is-loading{position:relative;pointer-events:none;opacity:.5}.box.is-loading:after{-webkit-animation:.5s linear infinite spinAround;animation:.5s linear infinite spinAround;border:.25em solid #000;border-radius:5em;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;position:absolute;top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.table{transition:opacity .2s;white-space:nowrap}.table.is-loading{position:relative;pointer-events:none;opacity:.5}.table.is-loading:after{-webkit-animation:.5s linear infinite spinAround;animation:.5s linear infinite spinAround;border:.25em solid #000;border-radius:5em;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;position:absolute;top:calc(50% - 2.5em);left:calc(50% - 2.5em);width:5em;height:5em}.table-wrapper{overflow-x:auto}.table th{vertical-align:middle;font-size:.75em}.sticky-row{background-color:#eef6fc;font-weight:700}select{font-weight:600}"] }]
    }], function () { return []; }, { data: [{
            type: Input
        }], aggregatedColumns: [{
            type: Input
        }], stickyRows: [{
            type: Input
        }], isFullWidth: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], isLoading: [{
            type: Input
        }], enableColumnSelection: [{
            type: Input
        }], enableCustomContent: [{
            type: Input
        }], staticColumns: [{
            type: Input
        }], selectedColumnsChange: [{
            type: Output
        }], selectedColumns: [{
            type: Input
        }], template: [{
            type: ContentChild,
            args: ['customContent', { static: false }]
        }], columnMappings: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    PivotTableComponent.prototype.template;
    /** @type {?} */
    PivotTableComponent.prototype.data;
    /** @type {?} */
    PivotTableComponent.prototype.columnMappings;
    /** @type {?} */
    PivotTableComponent.prototype.aggregatedColumns;
    /** @type {?} */
    PivotTableComponent.prototype.stickyRows;
    /** @type {?} */
    PivotTableComponent.prototype.isFullWidth;
    /** @type {?} */
    PivotTableComponent.prototype.itemsPerPage;
    /** @type {?} */
    PivotTableComponent.prototype.isLoading;
    /** @type {?} */
    PivotTableComponent.prototype.enableColumnSelection;
    /** @type {?} */
    PivotTableComponent.prototype.enableCustomContent;
    /** @type {?} */
    PivotTableComponent.prototype.staticColumns;
    /** @type {?} */
    PivotTableComponent.prototype._selectedColumns;
    /** @type {?} */
    PivotTableComponent.prototype.selectedColumnsChange;
    /** @type {?} */
    PivotTableComponent.prototype.currentPage;
    /** @type {?} */
    PivotTableComponent.prototype.rows;
    /** @type {?} */
    PivotTableComponent.prototype.groupedData;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
class Aggregators {
    /**
     * @param {?} numbers
     * @return {?}
     */
    static sum(numbers) {
        return numbers.reduce((/**
         * @param {?} prev
         * @param {?} curr
         * @return {?}
         */
        (prev, curr) => prev + curr), 0);
    }
    /**
     * @param {?} iterable
     * @return {?}
     */
    static count(iterable) {
        return new Set(iterable).size;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PaginatorComponent {
    constructor() {
        this.pageChange = new EventEmitter();
        this.totalItemsSubject = new BehaviorSubject(this.totalItems);
        this.currentPage = this.currentPage || 1;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.totalItemsSubject.pipe(delay(0)).subscribe((/**
         * @param {?} _
         * @return {?}
         */
        (_) => {
            if (this.currentPage <= 0) {
                this.currentPage = 1;
                this.pageChange.emit(this.currentPage);
            }
            if (this.lastPageNumber < this.currentPage) {
                this.currentPage = this.lastPageNumber;
                this.pageChange.emit(this.currentPage);
            }
        }));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.totalItems) {
            // If we filter from the last page, the total amount of items might change
            // and we end up with less items than the current page number supports
            this.totalItemsSubject.next(this.totalItems);
        }
    }
    /**
     * @param {?} pageNumber
     * @return {?}
     */
    goToPage(pageNumber) {
        this.currentPage = pageNumber;
        this.pageChange.emit(this.currentPage);
    }
    /**
     * @param {?} pageNumber
     * @return {?}
     */
    canGoToPage(pageNumber) {
        if (this.totalItems < this.itemsPerPage) {
            return false;
        }
        return pageNumber > 0;
    }
    /**
     * @return {?}
     */
    get lastPageNumber() {
        if (this.totalItems > 0) {
            return Math.ceil(this.totalItems / this.itemsPerPage);
        }
        return 1;
    }
    /**
     * @return {?}
     */
    get isOnFirstPage() {
        return this.currentPage === 1;
    }
    /**
     * @return {?}
     */
    get isOnLastPage() {
        return this.currentPage === this.lastPageNumber;
    }
    /**
     * @return {?}
     */
    get buttonOneNumber() {
        if (this.isOnFirstPage || this.lastPageNumber === 2) {
            return 1;
        }
        else if (this.isOnLastPage) {
            return this.lastPageNumber - 2;
        }
        else {
            return this.currentPage - 1;
        }
    }
    /**
     * @return {?}
     */
    get buttonTwoNumber() {
        if (this.isOnFirstPage || this.lastPageNumber === 2) {
            return 2;
        }
        else if (this.isOnLastPage) {
            return this.lastPageNumber - 1;
        }
        else {
            return this.currentPage;
        }
    }
    /**
     * @return {?}
     */
    get buttonThreeNumber() {
        if (this.isOnFirstPage) {
            return 3;
        }
        else if (this.isOnLastPage) {
            return this.lastPageNumber;
        }
        else {
            return this.currentPage + 1;
        }
    }
    /**
     * @return {?}
     */
    get canGoPrevious() {
        return this.currentPage > 1 && this.totalItems > this.itemsPerPage;
    }
    /**
     * @return {?}
     */
    get canGoNext() {
        return this.currentPage < this.lastPageNumber && this.totalItems > this.itemsPerPage;
    }
}
PaginatorComponent.ɵfac = function PaginatorComponent_Factory(t) { return new (t || PaginatorComponent)(); };
PaginatorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PaginatorComponent, selectors: [["agx-paginator"]], inputs: { currentPage: "currentPage", totalItems: "totalItems", itemsPerPage: "itemsPerPage" }, outputs: { pageChange: "pageChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "pagination", "role", "navigation", 4, "ngIf"], ["role", "navigation", 1, "pagination"], [4, "ngIf"], ["type", "button", 1, "pagination-previous", 3, "disabled", "click"], ["type", "button", 1, "pagination-next", 3, "disabled", "click"], [1, "pagination-list"], ["type", "button", 1, "pagination-link", 3, "ngClass", "click"], [1, "pagination-summary"], ["type", "button", 1, "pagination-previous", 3, "click"], ["type", "button", 1, "pagination-next", 3, "click"]], template: function PaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PaginatorComponent_nav_0_Template, 16, 12, "nav", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalItems > 0);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: [".pagination-link[_ngcontent-%COMP%]{text-align:center;padding:5px 10px;display:block;cursor:pointer}.pagination-next[_ngcontent-%COMP%], .pagination-previous[_ngcontent-%COMP%]{text-align:center;display:block;padding:5px 10px;cursor:pointer}.pagination-summary[_ngcontent-%COMP%]{padding-left:10px}"] });
/** @nocollapse */
PaginatorComponent.ctorParameters = () => [];
PaginatorComponent.propDecorators = {
    currentPage: [{ type: Input }],
    totalItems: [{ type: Input }],
    itemsPerPage: [{ type: Input }],
    pageChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginatorComponent, [{
        type: Component,
        args: [{ selector: 'agx-paginator', template: "<nav class=\"pagination\"\n     role=\"navigation\"\n     *ngIf=\"totalItems > 0\">\n\n  <ng-container *ngIf=\"currentPage > 1 && lastPageNumber > 1\">\n    <button class=\"pagination-previous\"\n            type=\"button\"\n            (click)=\"goToPage(1)\">\n      First\n    </button>\n  </ng-container>\n\n  <button class=\"pagination-previous\"\n          type=\"button\"\n          (click)=\"goToPage(currentPage - 1)\"\n          [disabled]=\"!canGoPrevious\">\n    Previous\n  </button>\n\n  <button class=\"pagination-next\"\n          type=\"button\"\n          (click)=\"goToPage(currentPage + 1)\"\n          [disabled]=\"!canGoNext\">\n    Next\n  </button>\n\n  <ng-container *ngIf=\"currentPage !== lastPageNumber && lastPageNumber > 1\">\n    <button class=\"pagination-next\"\n            type=\"button\"\n            (click)=\"goToPage(lastPageNumber)\">\n      Last\n    </button>\n  </ng-container>\n\n  <ul class=\"pagination-list\">\n    <li>\n      <button class=\"pagination-link\"\n              [ngClass]=\"{'is-current': currentPage === buttonOneNumber}\"\n              type=\"button\"\n              (click)=\"goToPage(buttonOneNumber)\">\n        {{buttonOneNumber}}\n      </button>\n    </li>\n    <li *ngIf=\"this.lastPageNumber > 1\">\n      <button class=\"pagination-link\"\n              type=\"button\"\n              [ngClass]=\"{'is-current': currentPage === buttonTwoNumber}\"\n              (click)=\"goToPage(buttonTwoNumber)\">\n        {{buttonTwoNumber}}\n      </button>\n    </li>\n    <li *ngIf=\"this.lastPageNumber > 2\">\n      <button class=\"pagination-link\"\n              type=\"button\"\n              [ngClass]=\"{'is-current': currentPage === buttonThreeNumber}\"\n              (click)=\"goToPage(buttonThreeNumber)\">\n        {{buttonThreeNumber}}\n      </button>\n    </li>\n    <li>\n      <span class=\"pagination-summary\">\n        Page {{currentPage}} of {{lastPageNumber}}\n      </span>\n    </li>\n  </ul>\n</nav>", styles: [".pagination-link{text-align:center;padding:5px 10px;display:block;cursor:pointer}.pagination-next,.pagination-previous{text-align:center;display:block;padding:5px 10px;cursor:pointer}.pagination-summary{padding-left:10px}"] }]
    }], function () { return []; }, { pageChange: [{
            type: Output
        }], currentPage: [{
            type: Input
        }], totalItems: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    PaginatorComponent.prototype.currentPage;
    /** @type {?} */
    PaginatorComponent.prototype.totalItems;
    /** @type {?} */
    PaginatorComponent.prototype.itemsPerPage;
    /** @type {?} */
    PaginatorComponent.prototype.pageChange;
    /**
     * @type {?}
     * @private
     */
    PaginatorComponent.prototype.totalItemsSubject;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const fadeInAnimation = trigger('fadeInAnimation', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0.25s ease', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        style({ opacity: 1, transform: 'translateX(0)' }),
        animate('0.25s ease', style({ opacity: 0 }))
    ])
]);
/** @type {?} */
const avatarAnimations = [
    fadeInAnimation
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AvatarComponent {
    constructor() {
        this.width = 80;
        this.isCentered = false;
        this.uploadProgress = 0;
        this.uploading = false;
        this.loadingImage = false;
        this.marginStyle = '';
    }
    /**
     * @return {?}
     */
    get initial() {
        if (!this.label) {
            return null;
        }
        return this.label.charAt(0).toUpperCase();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.marginStyle = this.isCentered ? '0 auto 0' : '';
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.avatarUrl) {
            this.loadingImage = true;
            /** @type {?} */
            const image = this.imageEl.nativeElement;
            image.src = this.avatarUrl;
            image.onload = (/**
             * @return {?}
             */
            () => {
                this.loadingImage = false;
            });
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.avatarUrl) {
            if (changes.avatarUrl.currentValue) {
                this.loadingImage = true;
                /** @type {?} */
                const image = this.imageEl.nativeElement;
                image.src = changes.avatarUrl.currentValue;
                image.onload = (/**
                 * @return {?}
                 */
                () => {
                    this.loadingImage = false;
                });
            }
        }
        if (changes.uploading && changes.uploading.currentValue && this.progressCircleEl) {
            /** @type {?} */
            const radius = (this.width / 2) - 2;
            /** @type {?} */
            const circumference = radius * 2 * Math.PI;
            this.progressCircleEl.nativeElement.style.strokeDasharray = `${circumference} ${circumference}`;
            /** @type {?} */
            const offset = circumference - this.uploadProgress / 100 * circumference;
            this.progressCircleEl.nativeElement.style.strokeDashoffset = offset.toString();
        }
        if (changes.uploadProgress && this.progressCircleEl) {
            /** @type {?} */
            const radius = (this.width / 2) - 2;
            /** @type {?} */
            const circumference = radius * 2 * Math.PI;
            /** @type {?} */
            const offset = circumference - changes.uploadProgress.currentValue / 100 * circumference;
            this.progressCircleEl.nativeElement.style.strokeDashoffset = offset.toString();
        }
    }
    /**
     * @return {?}
     */
    get fontSize() {
        if (this.width <= 30) {
            return '1rem';
        }
        else if (this.width <= 40) {
            return '1.5rem';
        }
        else {
            return '2.5rem';
        }
    }
    /**
     * @return {?}
     */
    get iconSize() {
        if (this.width <= 30) {
            return 'md';
        }
        else if (this.width <= 40) {
            return 'lg';
        }
        else {
            return 'lg';
        }
    }
}
AvatarComponent.ɵfac = function AvatarComponent_Factory(t) { return new (t || AvatarComponent)(); };
AvatarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AvatarComponent, selectors: [["agx-avatar"]], viewQuery: function AvatarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 7);
        ɵngcc0.ɵɵviewQuery(_c6, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.imageEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.progressCircleEl = _t.first);
    } }, inputs: { width: "width", isCentered: "isCentered", uploadProgress: "uploadProgress", uploading: "uploading", loadingImage: "loadingImage", avatarUrl: "avatarUrl", label: "label" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 9, vars: 20, consts: [[1, "avatar-wrapper"], ["class", "avatar", 3, "fontSize", 4, "ngIf"], [1, "avatar", 3, "ngClass"], ["image", ""], ["class", "avatar-loading", 4, "ngIf"], ["class", "avatar-uploading", 4, "ngIf"], [1, "progress-ring"], [1, "progress-ring-circle", 3, "ngClass"], ["progressRingCircle", ""], [1, "avatar"], [1, "avatar-loading"], ["aria-hidden", "true", "viewBox", "0 0 512 512", 1, "spinner"], ["d", "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z", 1, "secondary"], ["d", "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z", 1, "primary"], [1, "avatar-uploading"]], template: function AvatarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AvatarComponent_div_1_Template, 2, 4, "div", 1);
        ɵngcc0.ɵɵelement(2, "img", 2, 3);
        ɵngcc0.ɵɵtemplate(4, AvatarComponent_div_4_Template, 5, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, AvatarComponent_div_5_Template, 3, 2, "div", 5);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(6, "svg", 6);
        ɵngcc0.ɵɵelement(7, "circle", 7, 8);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.width, "px")("height", ctx.width, "px")("margin", ctx.marginStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.avatarUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c7, !ctx.avatarUrl || ctx.loadingImage));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadingImage || ctx.uploading && ctx.uploadProgress === 100);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.uploading && ctx.uploadProgress < 100);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("width", ctx.width / 1)("height", ctx.width / 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(18, _c8, ctx.uploading && ctx.uploadProgress > 0));
        ɵngcc0.ɵɵattribute("r", ctx.width / 2 - 2)("cx", ctx.width / 2)("cy", ctx.width / 2);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["@-webkit-keyframes _ngcontent-%COMP%_spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes _ngcontent-%COMP%_spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}.avatar-wrapper[_ngcontent-%COMP%]{position:relative;overflow:hidden;border-radius:50%;-webkit-filter:drop-shadow(0 3px .25rem rgba(0, 0, 0, .2));filter:drop-shadow(0 3px .25rem rgba(0, 0, 0, .2))}.avatar-wrapper[_ngcontent-%COMP%]   .avatar[_ngcontent-%COMP%]{position:absolute;display:flex;border-radius:50%;width:100%;height:100%;background-color:#ffc107;color:#ffff57;justify-content:center;flex-direction:column;text-align:center;transition:opacity 250ms}.avatar-wrapper[_ngcontent-%COMP%]   .avatar-loading[_ngcontent-%COMP%]{position:absolute;display:flex;border-radius:50%;width:100%;height:100%;background-color:rgba(0,0,0,.4);color:#fff;justify-content:center;flex-direction:column;text-align:center}.avatar-wrapper[_ngcontent-%COMP%]   .avatar-loading[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{-webkit-animation:.8s linear infinite _ngcontent-%COMP%_spin;animation:.8s linear infinite _ngcontent-%COMP%_spin;height:2rem}.avatar-wrapper[_ngcontent-%COMP%]   .avatar-loading[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]   g[_ngcontent-%COMP%]   .primary[_ngcontent-%COMP%]{fill:#43c8f1}.avatar-wrapper[_ngcontent-%COMP%]   .avatar-loading[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]   g[_ngcontent-%COMP%]   .secondary[_ngcontent-%COMP%]{fill:rgba(67,200,241,.3)}.avatar-wrapper[_ngcontent-%COMP%]   .avatar-uploading[_ngcontent-%COMP%]{position:absolute;display:flex;border-radius:50%;width:100%;height:100%;background-color:rgba(0,0,0,.4);color:#fff;justify-content:center;flex-direction:column;text-align:center}.progress-ring[_ngcontent-%COMP%]{position:absolute;left:0;top:0}.progress-ring[_ngcontent-%COMP%]   .progress-ring-circle[_ngcontent-%COMP%]{stroke:#43c8f1;fill:transparent;stroke-width:0;stroke-dasharray:10 20;transition:.3s;transform:rotate(-90deg);transform-origin:50% 50%}.progress-ring[_ngcontent-%COMP%]   .progress-ring-circle.visible[_ngcontent-%COMP%]{stroke-width:5}.invisible[_ngcontent-%COMP%]{opacity:0}"], data: { animation: [...avatarAnimations] } });
/** @nocollapse */
AvatarComponent.ctorParameters = () => [];
AvatarComponent.propDecorators = {
    avatarUrl: [{ type: Input }],
    label: [{ type: Input }],
    width: [{ type: Input }],
    isCentered: [{ type: Input }],
    uploadProgress: [{ type: Input }],
    uploading: [{ type: Input }],
    loadingImage: [{ type: Input }],
    imageEl: [{ type: ViewChild, args: ['image', { static: true },] }],
    progressCircleEl: [{ type: ViewChild, args: ['progressRingCircle', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AvatarComponent, [{
        type: Component,
        args: [{ selector: 'agx-avatar', template: "<div class=\"avatar-wrapper\"\n     [style.width.px]=\"width\"\n     [style.height.px]=\"width\"\n     [style.margin]=\"marginStyle\">\n\n  <div *ngIf=\"!avatarUrl\"\n       class=\"avatar\"\n       [style.fontSize]=\"fontSize\"\n       [@fadeInAnimation]>\n    {{ initial }}\n  </div>\n\n  <img #image\n       [ngClass]=\"{'invisible': !avatarUrl || loadingImage}\"\n       class=\"avatar\" />\n\n  <div class=\"avatar-loading\"\n       *ngIf=\"loadingImage || (uploading && uploadProgress === 100)\"\n       [@fadeInAnimation]>\n    <svg aria-hidden=\"true\"\n         viewBox=\"0 0 512 512\"\n         class=\"spinner\">\n      <g>\n        <path d=\"M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z\"\n              class=\"secondary\"></path>\n        <path d=\"M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z\"\n              class=\"primary\"></path>\n      </g>\n    </svg>\n  </div>\n\n  <div *ngIf=\"uploading && uploadProgress < 100\"\n       class=\"avatar-uploading\"\n       [@fadeInAnimation]>\n    <b>{{ uploadProgress }}%</b>\n  </div>\n\n  <svg class=\"progress-ring\"\n       [attr.width]=\"(width/1)\"\n       [attr.height]=\"(width/1)\">\n    <circle class=\"progress-ring-circle\"\n            [ngClass]=\"{'visible': uploading && uploadProgress > 0}\"\n            #progressRingCircle\n            [attr.r]=\"(width/2)-2\"\n            [attr.cx]=\"(width/2)\"\n            [attr.cy]=\"(width/2)\" />\n  </svg>\n\n</div>", animations: [...avatarAnimations], styles: ["@-webkit-keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}.avatar-wrapper{position:relative;overflow:hidden;border-radius:50%;-webkit-filter:drop-shadow(0 3px .25rem rgba(0, 0, 0, .2));filter:drop-shadow(0 3px .25rem rgba(0, 0, 0, .2))}.avatar-wrapper .avatar{position:absolute;display:flex;border-radius:50%;width:100%;height:100%;background-color:#ffc107;color:#ffff57;justify-content:center;flex-direction:column;text-align:center;transition:opacity 250ms}.avatar-wrapper .avatar-loading{position:absolute;display:flex;border-radius:50%;width:100%;height:100%;background-color:rgba(0,0,0,.4);color:#fff;justify-content:center;flex-direction:column;text-align:center}.avatar-wrapper .avatar-loading .spinner{-webkit-animation:.8s linear infinite spin;animation:.8s linear infinite spin;height:2rem}.avatar-wrapper .avatar-loading .spinner g .primary{fill:#43c8f1}.avatar-wrapper .avatar-loading .spinner g .secondary{fill:rgba(67,200,241,.3)}.avatar-wrapper .avatar-uploading{position:absolute;display:flex;border-radius:50%;width:100%;height:100%;background-color:rgba(0,0,0,.4);color:#fff;justify-content:center;flex-direction:column;text-align:center}.progress-ring{position:absolute;left:0;top:0}.progress-ring .progress-ring-circle{stroke:#43c8f1;fill:transparent;stroke-width:0;stroke-dasharray:10 20;transition:.3s;transform:rotate(-90deg);transform-origin:50% 50%}.progress-ring .progress-ring-circle.visible{stroke-width:5}.invisible{opacity:0}"] }]
    }], function () { return []; }, { width: [{
            type: Input
        }], isCentered: [{
            type: Input
        }], uploadProgress: [{
            type: Input
        }], uploading: [{
            type: Input
        }], loadingImage: [{
            type: Input
        }], avatarUrl: [{
            type: Input
        }], label: [{
            type: Input
        }], imageEl: [{
            type: ViewChild,
            args: ['image', { static: true }]
        }], progressCircleEl: [{
            type: ViewChild,
            args: ['progressRingCircle', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    AvatarComponent.prototype.avatarUrl;
    /** @type {?} */
    AvatarComponent.prototype.label;
    /** @type {?} */
    AvatarComponent.prototype.width;
    /** @type {?} */
    AvatarComponent.prototype.isCentered;
    /** @type {?} */
    AvatarComponent.prototype.uploadProgress;
    /** @type {?} */
    AvatarComponent.prototype.uploading;
    /** @type {?} */
    AvatarComponent.prototype.loadingImage;
    /** @type {?} */
    AvatarComponent.prototype.marginStyle;
    /** @type {?} */
    AvatarComponent.prototype.imageEl;
    /** @type {?} */
    AvatarComponent.prototype.progressCircleEl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OpenAgriComponentsService {
    constructor() { }
}
OpenAgriComponentsService.ɵfac = function OpenAgriComponentsService_Factory(t) { return new (t || OpenAgriComponentsService)(); };
OpenAgriComponentsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OpenAgriComponentsService, factory: OpenAgriComponentsService.ɵfac, providedIn: 'root' });
/** @nocollapse */
OpenAgriComponentsService.ctorParameters = () => [];
/** @nocollapse */ OpenAgriComponentsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function OpenAgriComponentsService_Factory() { return new OpenAgriComponentsService(); }, token: OpenAgriComponentsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OpenAgriComponentsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OpenAgriComponentsModule {
}
OpenAgriComponentsModule.ɵfac = function OpenAgriComponentsModule_Factory(t) { return new (t || OpenAgriComponentsModule)(); };
OpenAgriComponentsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OpenAgriComponentsModule });
OpenAgriComponentsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OpenAgriComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [PivotTableComponent, PaginatorComponent, AvatarComponent],
                imports: [
                    CommonModule
                ],
                exports: [PivotTableComponent, PaginatorComponent, AvatarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OpenAgriComponentsModule, { declarations: function () { return [PivotTableComponent, PaginatorComponent, AvatarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PivotTableComponent, PaginatorComponent, AvatarComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Aggregators, AvatarComponent, OpenAgriComponentsModule, OpenAgriComponentsService, PaginatorComponent, PivotTableComponent, fadeInAnimation as ɵa, avatarAnimations as ɵb };

